import React from 'react'
import { UnorderedListOutlined, PoweroffOutlined } from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { Layout, Menu } from 'antd'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useStoreActions } from '../../store'

const getMenuItem = (url: string, label: string) => ({
  key: url,
  label: <Link href={url}>{label}</Link>
})

const SideBar: React.FC = () => {
  const router = useRouter()
  const path = router.pathname.split('/')[1]
  const isStaff = useStoreActions(actions => actions.auth).userHasRole('staff')

  const items: MenuProps['items'] = [
    {
      key: 'rate-sets',
      icon: <UnorderedListOutlined />,
      label: 'Rate Sets',
      children: isStaff
        ? [
            getMenuItem('/rate-sets/create', 'Create'),
            getMenuItem('/rate-sets', 'List')
          ]
        : [getMenuItem('/rate-sets', 'List')]
    }
  ]

  if (isStaff) {
    items.push({
      key: 'indexes',
      icon: <UnorderedListOutlined />,
      label: <Link href={`/indexes`}>Cost of Funds</Link>
    })
  }

  const BAP_ENV = process.env.APP_ENV === 'prod' ? '' : 'qa.'
  const bapBaseUrl = `https://advertiser.${BAP_ENV}bankrate.com`

  items.push({
    key: 'logout',
    icon: <PoweroffOutlined />,
    label: <Link href={`${bapBaseUrl}/logout`}>Logout</Link>
  })

  return (
    <Layout.Sider className="main-nav">
      <div className="logo">
        <Link href={bapBaseUrl}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src="/images/bankrate-logo.svg" alt="Bankrate" />
        </Link>
      </div>
      <Menu
        style={{ width: 200, marginTop: 40 }}
        defaultSelectedKeys={[path || 'rate-sets']}
        defaultOpenKeys={[path || 'rate-sets']}
        selectedKeys={[router.pathname]}
        mode="inline"
        theme="dark"
        items={items}
      />
    </Layout.Sider>
  )
}

export default SideBar
